import React from 'react';
import styled from 'styled-components';
import { Flex } from 'rebass';

const Circle = styled.div.attrs({
    className: 'circle'
})`
    margin-top: 1px;
    width: 8px;
    height: 8px;
`;

const Container = styled(Flex).attrs({
    className: 'fs-accent-14'
})`
    align-items: center;
    gap: 8px;
`;

const colorClassNames = {
    green: {
        statusCircle: 'color-bg-success',
        text: 'color-text-primary'
    },
    orange: {
        statusCircle: 'color-bg-warning',
        text: 'color-text-primary'
    },
    red: {
        statusCircle: 'color-bg-error',
        text: 'color-text-primary'
    },
    gray: {
        statusCircle: 'color-bg-text-muted',
        text: 'color-text-secondary'
    }
};

const StatusLabel = props => {
    const colorClassName = colorClassNames[props.color] || colorClassNames.red;

    return (
        <Container>
            <Circle className={colorClassName.statusCircle} />
            <div className={colorClassName.text}>{props.status}</div>
        </Container>
    );
};

export default StatusLabel;
